// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-results{font-size:20px;font-weight:500;color:#0a1343}`, "",{"version":3,"sources":["webpack://./src/packages/search/components/Search.scss"],"names":[],"mappings":"AAAA,gBACE,cAAA,CACA,eAAA,CACA,aAAA","sourcesContent":[".search-results {\n  font-size: 20px;\n  font-weight: 500;\n  color: #0a1343;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
